module.exports = __webpack_public_path__ + "img/carousel-0.85e2f099.png";